export const FIRST_REFETCH_INTERVAL = 1000;
export const MAX_EXTERNAL_RECIPIENT_EMAILS_COUNT = 10;
export const MAX_REPORT_RECIPIENT_EMAILS_COUNT = 150;
export const DATE_RANGE_DESKTOP_MONTHS_SHOWN = 1;
export const DATE_RANGE_MOBILE_MONTHS_SHOWN = 37;
export const EMAIL_REGEXP = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const DATA_TEST_IDS = {
  MODAL: 'modal_request_ad_campaigns_by_days_report',
  DATE_RANGE_INPUT: 'input_ad_campaigns_report_date_range',
  PROMO_SELECT: 'request_ad_campaigns_by_days_report_promo_select',
  PROMO_TRIGGER: 'button_request_ad_campaigns_by_days_report_promo',
  PROMO_TRIGGER_ICON: 'icon_request_ad_campaigns_by_days_report_promo_trigger',
  PROMO_DROPDOWN: 'dropdown_request_ad_campaigns_by_days_report_promo',
  PROMO_EMPTY: 'request_ad_campaigns_by_days_report_promo_empty',
  PROMO_ERROR: 'request_ad_campaigns_by_days_report_promo_error',
  PROMO_RETRY: 'button_request_ad_campaigns_by_days_report_promo_retry',
  PROMO_OPTION: (promoId: string) => `request_ad_campaigns_by_days_report_promo_option_${promoId}`,
  PROMO_OPTION_RADIO: (promoId: string) => `radio_request_ad_campaigns_by_days_report_promo_${promoId}`,
  PROMO_OPTION_PLAY: (promoId: string) => `button_request_ad_campaigns_by_days_report_promo_play_${promoId}`,
  SUBMIT_BUTTON: 'button_submit_request_ad_campaigns_by_days_report_modal',
  CANCEL_BUTTON: 'button_cancel_request_ad_campaigns_by_days_report_modal',
};
